import { useResizeObserver } from "@amzn/stencil-react-components/hooks";
import { Col, View } from "@amzn/stencil-react-components/layout";
import { Spinner, SpinnerSize } from "@amzn/stencil-react-components/spinner";
import { SearchResult } from "common/components";
import React, { FC, useLayoutEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";

interface SearchResultItem {
  taxonomyId: string;
  name: string;
  logoUrl?: string;
  shortDescription?: string;
}

export interface CatalogItemsListProps {
  scrollableTarget: string;
  items: SearchResultItem[];
  isLoading: boolean;
  isLoadingNextItems: boolean;
  totalCount: number;
  shouldLoadMore: () => boolean;
  onSearchNext: () => void;
}

const SearchItemsList: FC<CatalogItemsListProps> = (props) => {
  const { ref, height } = useResizeObserver<HTMLDivElement>();

  const hasMoreItems = () => {
    return props.items!.length < props.totalCount!;
  };

  useLayoutEffect(() => {
    if (!hasMoreItems()) {
      return;
    }

    if (props.shouldLoadMore()) {
      props.onSearchNext();
    }
  }, [height, props.isLoadingNextItems, props.isLoading]);

  const itemsComponents = props.items!.map((item) => (
    <SearchResult
      key={item.taxonomyId}
      taxonomyId={item.taxonomyId}
      logoUrl={item.logoUrl || ""}
      name={item.name}
      shortDescription={item.shortDescription || ""}
      available=""
      lists={[]}
    />
  ));

  return (
    <Col data-testid="search-results-list" ref={ref}>
      <InfiniteScroll
        dataLength={itemsComponents.length}
        next={props.onSearchNext}
        hasMore={hasMoreItems()}
        loader={
          <View padding="S700">
            <Spinner size={SpinnerSize.Medium} />
          </View>
        }
        scrollableTarget={props.scrollableTarget}
      >
        {itemsComponents}
      </InfiniteScroll>
    </Col>
  );
};

export default SearchItemsList;
